var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSleepNoStar = function SvgSleepNoStar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#1A1A2C",
    fillOpacity: 0.7,
    fillRule: "evenodd",
    d: "M12.541 21.875c-4.065 0-7.762-2.555-9.2-6.359a.485.485 0 0 1 .61-.63 8.848 8.848 0 0 0 2.862.474c4.887 0 8.863-3.976 8.863-8.863a8.826 8.826 0 0 0-.571-3.132.485.485 0 0 1 .61-.63 9.831 9.831 0 0 1 6.66 9.306c0 5.423-4.411 9.834-9.834 9.834Z",
    clipRule: "evenodd"
  })));
};
export default SvgSleepNoStar;